// extracted by mini-css-extract-plugin
export var currencyInput = "DepositAmountInput-module--currencyInput--a3785";
export var currencyInputWrapper = "DepositAmountInput-module--currencyInputWrapper--d1661";
export var depositAmountContainer = "DepositAmountInput-module--depositAmountContainer--dc187";
export var disabled = "DepositAmountInput-module--disabled--50e13";
export var errorMessage = "DepositAmountInput-module--errorMessage--b7b46";
export var textMd = "DepositAmountInput-module--textMd--72aef";